





























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class HeaderLayout extends Vue {

  private showShadow = false

  private onScroll(e: any) {
    this.showShadow = e.target.scrollTop > 10;
  }
}
